<template>
  <div id="app">
    <Loader v-if="isLoading"/>
    <router-view/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { Loader } from '@wizepe/wize-admin'

export default {
  mounted() {
    document.documentElement.style.setProperty('--color-primary', '#00BCD4')
    document.documentElement.style.setProperty('--color-primary-dark', '#09A8BC')
  },
  components: {
    Loader
  },
  computed: {
    ...mapGetters({
      isLoading: 'app/isLoading'
    })
  },
}
</script>

<style>
</style>
